import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function inquiryStatusColumnsSpecificataion(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const resolvedColumn = { 
        id: "resolvedDate",
        width: 15,
        hideLabel: false,
        data: {displayInBodyAs: "string", displayInBodyAsIs: true, displayInHeadAs: "string"},
        showInMobileViewAs: "primary", isCountryCode: false 
    };

    const newCols = [ ...config.columns, resolvedColumn ];

    const tableRows = config.data.length && config.data[0].disputeStatus === "RESOLVED" ? { ...config, columns: newCols } : config;
    tableRows.data.forEach((order) => {
        let row = [];
        const rowId = order.orderId;

        tableRows.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;

            let columnValue = null;
            if (columnDataType === "string") {
                if (columnId === "disputed") {
                    columnValue = order.disputed;
                }
                else if (columnId === "disputeRequestDate") {
                    columnValue = getDateWithSpecificFormat(order.disputeRequestDate) || "";
                }
                else if (columnId === "customerComments") {
                    columnValue = order.disputeCustomerComment;
                }
                else if (columnId === "disputeStatus") {
                    columnValue = order.disputeStatus;
                }
                else if (columnId === "resolvedDate") {
                    columnValue = getDateWithSpecificFormat(order.disputeResolvedDate);
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = tableRows.columns || [];
    result['data'] = tableData || [];
    return result;
}
